"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var EditableLabelDirective = /** @class */ (function () {
    function EditableLabelDirective() {
        this.restrict = 'A';
        this.controller = EditableLabelDirectiveLinker;
        this.controllerAs = 'editableLabel';
        this.scope = {
            saveCallback: '&',
            originalValue: '@'
        };
        this.transclude = true;
        this.template = '<ng-transclude></ng-transclude> ' +
            '<i class="fa fa-check editable-label-pencil" ng-click="editableLabel.cancelEdit()" ng-show="editableLabel.isEditable"></i>' +
            '<i class="fa fa-times editable-label-pencil" ng-click="editableLabel.cancelEdit()" ng-show="editableLabel.isEditable"></i>' +
            '<i class="fa fa-pencil editable-label-pencil" ng-click="editableLabel.startEdit()" ng-hide="editableLabel.isEditable"></i>';
    }
    EditableLabelDirective.create = function () {
        return new EditableLabelDirective();
    };
    return EditableLabelDirective;
}());
exports.EditableLabelDirective = EditableLabelDirective;
var EditableLabelDirectiveLinker = /** @class */ (function () {
    function EditableLabelDirectiveLinker($scope, $element) {
        this.$scope = $scope;
        this.$element = $element;
        this.isEditable = false;
        this.originalValue = $scope.originalValue;
        this.value = this.originalValue;
        this.editableField = $element.find('.editable-field');
        $element.blur(this.cancelEdit);
    }
    EditableLabelDirectiveLinker.prototype.cancelEdit = function () {
        this.editableField.removeAttr('contentEditable');
        this.value = this.originalValue;
        this.isEditable = false;
    };
    EditableLabelDirectiveLinker.prototype.startEdit = function () {
        this.editableField.attr('contentEditable', 'true');
        this.editableField.focus();
        this.isEditable = true;
    };
    return EditableLabelDirectiveLinker;
}());
exports.EditableLabelDirectiveLinker = EditableLabelDirectiveLinker;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZWRpdGFibGVMYWJlbC5kaXJlY3RpdmUuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJlZGl0YWJsZUxhYmVsLmRpcmVjdGl2ZS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOztBQUVBO0lBQUE7UUFDSSxhQUFRLEdBQVcsR0FBRyxDQUFDO1FBQ3ZCLGVBQVUsR0FBRyw0QkFBNEIsQ0FBQztRQUMxQyxpQkFBWSxHQUFXLGVBQWUsQ0FBQztRQUN2QyxVQUFLLEdBQVE7WUFDVCxZQUFZLEVBQUUsR0FBRztZQUNqQixhQUFhLEVBQUUsR0FBRztTQUNyQixDQUFDO1FBQ0YsZUFBVSxHQUFHLElBQUksQ0FBQztRQUNsQixhQUFRLEdBQVcsa0NBQWtDO1lBQ2pELDRIQUE0SDtZQUM1SCw0SEFBNEg7WUFDNUgsNEhBQTRILENBQUM7SUFNckksQ0FBQztJQUhVLDZCQUFNLEdBQWI7UUFDSSxPQUFPLElBQUksc0JBQXNCLEVBQUUsQ0FBQztJQUN4QyxDQUFDO0lBQ0wsNkJBQUM7QUFBRCxDQUFDLEFBbEJELElBa0JDO0FBbEJZLHdEQUFzQjtBQW9CbkM7SUFNSSxzQ0FBbUIsTUFBVyxFQUFTLFFBQTBCO1FBQTlDLFdBQU0sR0FBTixNQUFNLENBQUs7UUFBUyxhQUFRLEdBQVIsUUFBUSxDQUFrQjtRQUoxRCxlQUFVLEdBQVksS0FBSyxDQUFDO1FBSy9CLElBQUksQ0FBQyxhQUFhLEdBQUcsTUFBTSxDQUFDLGFBQWEsQ0FBQztRQUMxQyxJQUFJLENBQUMsS0FBSyxHQUFHLElBQUksQ0FBQyxhQUFhLENBQUM7UUFDaEMsSUFBSSxDQUFDLGFBQWEsR0FBRyxRQUFRLENBQUMsSUFBSSxDQUFDLGlCQUFpQixDQUFDLENBQUM7UUFFdEQsUUFBUSxDQUFDLElBQUksQ0FBQyxJQUFJLENBQUMsVUFBVSxDQUFDLENBQUM7SUFDbkMsQ0FBQztJQUVNLGlEQUFVLEdBQWpCO1FBQ0ksSUFBSSxDQUFDLGFBQWEsQ0FBQyxVQUFVLENBQUMsaUJBQWlCLENBQUMsQ0FBQztRQUNqRCxJQUFJLENBQUMsS0FBSyxHQUFHLElBQUksQ0FBQyxhQUFhLENBQUM7UUFDaEMsSUFBSSxDQUFDLFVBQVUsR0FBRyxLQUFLLENBQUM7SUFDNUIsQ0FBQztJQUVNLGdEQUFTLEdBQWhCO1FBQ0ksSUFBSSxDQUFDLGFBQWEsQ0FBQyxJQUFJLENBQUMsaUJBQWlCLEVBQUUsTUFBTSxDQUFDLENBQUM7UUFDbkQsSUFBSSxDQUFDLGFBQWEsQ0FBQyxLQUFLLEVBQUUsQ0FBQztRQUMzQixJQUFJLENBQUMsVUFBVSxHQUFHLElBQUksQ0FBQztJQUMzQixDQUFDO0lBQ0wsbUNBQUM7QUFBRCxDQUFDLEFBekJELElBeUJDO0FBekJZLG9FQUE0QiJ9